/*
 * The quote form: pick products, set quantities, send the list.
 *
 * Products are found through the shop's own search, so the line carries a
 * real variant id and the draft order the salesperson opens is already
 * itemised rather than a paragraph to decipher.
 */
(function () {
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();

  function start() {
    var form = document.querySelector('[data-sb-quote]');
    if (!form) return;

    var lines = form.querySelector('[data-sb-quote-lines]');
    var status = form.querySelector('[data-sb-quote-status]');
    var index = 0;

    function addLine() {
      var id = 'q-line-' + index++;
      var row = document.createElement('div');
      row.className = 'sb-quote-line';
      row.innerHTML =
        '<div class="sb-quote-line__product">' +
        '<label for="' + id + '">Product</label>' +
        '<input type="text" id="' + id + '" class="sb-quote-line__search" placeholder="Start typing a product name" autocomplete="off">' +
        '<input type="hidden" class="sb-quote-line__variant">' +
        '<ul class="sb-quote-line__results" hidden></ul>' +
        '</div>' +
        '<div class="sb-quote-line__qty"><label for="' + id + '-q">Quantity</label>' +
        '<input type="number" id="' + id + '-q" min="1" step="1" class="sb-quote-line__quantity" placeholder="250"></div>' +
        '<button type="button" class="sb-quote-line__remove" aria-label="Remove this line">&times;</button>';
      lines.appendChild(row);
    }

    async function search(term, list, hidden, input) {
      if (term.length < 2) { list.hidden = true; return; }
      var res = await fetch('/search/suggest.json?q=' + encodeURIComponent(term) + '&resources[type]=product&resources[limit]=6');
      var data = await res.json();
      var products = (data.resources.results.products || []).filter(function (p) {
        // Companion products carry the price variants and are not for sale.
        return p.handle.indexOf('blazon-custom-') !== 0;
      });
      list.innerHTML = products
        .map(function (p) { return '<li><button type="button" data-handle="' + p.handle + '">' + p.title + '</button></li>'; })
        .join('');
      list.hidden = !products.length;

      list.querySelectorAll('button').forEach(function (button) {
        button.addEventListener('click', async function () {
          var product = await fetch('/products/' + button.dataset.handle + '.js').then(function (r) { return r.json(); });
          input.value = product.title;
          hidden.value = 'gid://shopify/ProductVariant/' + product.variants[0].id;
          list.hidden = true;
        });
      });
    }

    lines.addEventListener('input', function (e) {
      if (!e.target.classList.contains('sb-quote-line__search')) return;
      var row = e.target.closest('.sb-quote-line');
      search(e.target.value.trim(), row.querySelector('.sb-quote-line__results'), row.querySelector('.sb-quote-line__variant'), e.target);
    });

    lines.addEventListener('click', function (e) {
      if (!e.target.classList.contains('sb-quote-line__remove')) return;
      var rows = lines.querySelectorAll('.sb-quote-line');
      if (rows.length > 1) e.target.closest('.sb-quote-line').remove();
    });

    form.querySelector('[data-sb-quote-add]').addEventListener('click', addLine);

    form.addEventListener('submit', async function (e) {
      e.preventDefault();
      status.hidden = true;
      status.classList.remove('is-error');

      var payload = {
        name: form.querySelector('#q-name').value,
        email: form.querySelector('#q-email').value,
        company: form.querySelector('#q-company').value,
        phone: form.querySelector('#q-phone').value,
        neededBy: form.querySelector('#q-needed').value,
        message: form.querySelector('#q-message').value,
        lines: [].slice.call(lines.querySelectorAll('.sb-quote-line')).map(function (row) {
          return {
            variantId: row.querySelector('.sb-quote-line__variant').value,
            quantity: parseInt(row.querySelector('.sb-quote-line__quantity').value, 10) || 0,
          };
        }).filter(function (line) { return line.variantId && line.quantity > 0; }),
      };

      var button = form.querySelector('button[type="submit"]');
      button.disabled = true;
      var label = button.textContent;
      button.textContent = 'Sending…';
      try {
        var res = await fetch('/apps/blazon/api/quote', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
        });
        var body = await res.json();
        if (!res.ok) throw new Error(body.error || 'We could not send that.');
        form.reset();
        lines.innerHTML = '';
        addLine();
        status.textContent = body.message + ' Reference ' + body.quote + '.';
        status.hidden = false;
      } catch (err) {
        status.textContent = err.message;
        status.classList.add('is-error');
        status.hidden = false;
      } finally {
        button.disabled = false;
        button.textContent = label;
      }
    });

    addLine();

    // Arriving from a product page, the first line starts on that product.
    var wanted = new URLSearchParams(location.search).get('product');
    if (wanted) {
      fetch('/products/' + wanted + '.js')
        .then(function (r) { return r.json(); })
        .then(function (product) {
          var row = lines.querySelector('.sb-quote-line');
          row.querySelector('.sb-quote-line__search').value = product.title;
          row.querySelector('.sb-quote-line__variant').value = 'gid://shopify/ProductVariant/' + product.variants[0].id;
        })
        .catch(function () {});
    }
  }
})();
